<template>
	<div style="margin-left:50px">
	  <div class="subTop">
	    <em>Research Report</em>
	    <span>研究报告</span>
	    <router-link to="/baogao" class="more" @click.native="$track([['pagetype','首页-研究报告-更多-点击']])">更多</router-link>
	  </div>
	  <a @click="yanjiuList.data[0].id?jumppush('/detail/'+yanjiuList.data[0].id):''" class="top top1">
	    <img :src="yanjiuList.data?yanjiuList.images[yanjiuList.data[0].id]:''"/>
	    <p>{{yanjiuList.data?yanjiuList.data[0].title:''}}</p>
	  </a>
	  <ul class="newsWap newsWap1">
			<li v-for="(item,index) in yanjiuList.data" v-if="index>0&&index<5">
				<a @click="jumppush('/detail/'+item.id)" :title="item.title"><span v-if="item.articletype=='3127cb593d6640a18d1c73bb6b6d375d'">【中经专稿】</span>{{item.title}}</a>
			</li>
	    <!-- <li><a href="##">【中经专稿】必须将半导体供给生命线把控在自己手中</a></li>
	    <li><a href="##">【中经专稿】我国芯片行业在美国打压下强劲增长</a></li>
	    <li><a href="##">中国信通院发布白皮书：新IT重塑企业数字化转型</a></li>
	    <li><a href="##">智慧城市标准化白皮书（2022版）</a></li> -->
	  </ul>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				isloading:true,
				yanjiuList: [],
			}
		},
		created:function(){
			this.yanjiufnc();
		},
		computed: {
	
		},
		methods: {
			showLogin: function() {
				this.$emit('showLogin');
			},
			jumppush:function(to){
				if(!this.$cookies.get('userinfo')){
					this.showLogin();
					return false;
				}
				else{
					var a = document.createElement('a');
					a.setAttribute('href', to);
					a.setAttribute('style', 'display:none');  
					a.setAttribute('target', '_blank');  
					document.body.appendChild(a);
					a.click();
					a.parentNode.removeChild(a); 
				}
			},
			yanjiufnc: function() {
				let _this = this;
				// this.resultDataList = {};
				// this.totalResultCount = 0;
				this.$http({
						method: 'get',
						url: 'szjj/searchArticles',
						responseType: 'json',
						params: {
							columnID: 'e358666c57e244d9a854a99452c238b1',
							// isTopArticle: '1',
							iPage:'1',
							pageSize:'5',
						},
					})
					.then(function(response) {
						// console.log(response);
						// debugger;
						_this.yanjiuList = response.data.data.data;
						_this.isloading=false;
					})
					.catch(function(error) {
						console.log(error);
					});
			},
		}
	}
</script>

<style>
</style>
